/**
 * Small visual primitives shared across the Content Studio surface.
 * Kept tiny and dependency-light so they can be reused elsewhere (e.g.
 * future ContentStudio sub-tabs) without lifting state.
 */

export function ScoreBadge({ score }) {
  let cls = "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (score < 70) cls = "bg-amber-50 text-amber-800 border-amber-200";
  if (score < 50) cls = "bg-red-50 text-red-700 border-red-200";
  return <span className={`border px-2 py-0.5 font-mono-data text-xs ${cls}`}>{score}/100</span>;
}

export function Stat({ label, value }) {
  return (
    <div className="bg-white p-3 border-r border-b border-border">
      <div className="font-mono-data text-[10px] uppercase tracking-widest text-muted-foreground">
        {label}
      </div>
      <div className="font-semibold text-lg mt-0.5">{value}</div>
    </div>
  );
}

/** Minimal markdown renderer for AI feedback / inline previews. */
export function SimpleMd({ text }) {
  if (!text) return null;
  return (
    <div className="space-y-2 text-sm">
      {text.split("\n").map((line, i) => {
        if (line.startsWith("- ") || line.startsWith("* ")) {
          return (
            <div key={i} className="flex gap-2">
              <span className="text-primary">›</span>
              <span
                dangerouslySetInnerHTML={{
                  __html: line.slice(2).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>"),
                }}
              />
            </div>
          );
        }
        if (line.trim() === "") return <div key={i} className="h-1" />;
        return (
          <p
            key={i}
            dangerouslySetInnerHTML={{
              __html: line.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>"),
            }}
          />
        );
      })}
    </div>
  );
}
